import React, { useEffect, useState } from 'react';

const API_URL = "https://v6d18bgl57.execute-api.us-west-1.amazonaws.com/prod/admin-waf-logs";

const WAFLogViewer = ({ user }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); // all, blocked, allowed

  useEffect(() => {
    const token = user?.signInUserSession?.idToken?.jwtToken;
    if (!token) {
      console.error("No JWT token available");
      setLoading(false);
      return;
    }

    fetch(API_URL, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
        setLogs(data.logs || []);
        setLoading(false);
      })
      .catch(err => {
        console.error("❌ Failed to load WAF logs:", err);
        setLoading(false);
      });
  }, [user]);

  const filteredLogs = logs.filter(log => {
    if (filter === 'all') return true;
    if (filter === 'blocked') return log.action === 'BLOCK';
    if (filter === 'allowed') return log.action === 'ALLOW';
    return true;
  });

  const getActionBadge = (action) => {
    const color = action === 'BLOCK' ? 'danger' : 'success';
    return <span className={`badge bg-${color}`}>{action}</span>;
  };

  return (
    <div className="container mt-4">
      <h2>WAF Security Logs</h2>

      <div className="mb-3">
        <div className="btn-group" role="group">
          <button
            className={`btn btn-sm ${filter === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setFilter('all')}
          >
            All Requests
          </button>
          <button
            className={`btn btn-sm ${filter === 'blocked' ? 'btn-danger' : 'btn-outline-danger'}`}
            onClick={() => setFilter('blocked')}
          >
            Blocked
          </button>
          <button
            className={`btn btn-sm ${filter === 'allowed' ? 'btn-success' : 'btn-outline-success'}`}
            onClick={() => setFilter('allowed')}
          >
            Allowed
          </button>
        </div>
      </div>

      {loading ? (
        <p>Loading WAF logs...</p>
      ) : (
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>Client IP</th>
              <th>Method</th>
              <th>URI</th>
              <th>Action</th>
              <th>Rule ID</th>
              <th>Country</th>
            </tr>
          </thead>
          <tbody>
            {filteredLogs.map((log, idx) => (
              <tr key={idx}>
                <td>{new Date(log.timestamp).toLocaleString()}</td>
                <td>{log.clientIp}</td>
                <td>{log.method}</td>
                <td>{log.uri}</td>
                <td>{getActionBadge(log.action)}</td>
                <td>{log.ruleId || '—'}</td>
                <td>{log.country || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default WAFLogViewer;
